import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ReplacementReason } from '@app/features/contracts/replacement-reason.model';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { BehaviorSubject, Observable } from 'rxjs';

export interface IReplacementReasonService {
  allReplacementReasons$: Observable<ReplacementReason[]>;
}

@Injectable({
  providedIn: 'root',
})
export class ReplacementReasonService {
  private http = inject(HttpClient);

  private url = `${inject(RUNTIME_CONFIG).apiUrl}/contracts/replacement-reasons`;
  private _allReplacementReasonsSubject = new BehaviorSubject<ReplacementReason[]>([]);

  constructor() {
    this.loadAllReplacementReasons();
  }

  get allReplacementReasons$(): Observable<ReplacementReason[]> {
    return this._allReplacementReasonsSubject.asObservable();
  }

  private loadAllReplacementReasons() {
    this.http.get<ReplacementReason[]>(this.url).subscribe((replacementReasons) => {
      this._allReplacementReasonsSubject.next(replacementReasons);
    });
  }
}
